import React from 'react';
import {
  ScrollView,
  TouchableOpacity,
  View,
  useWindowDimensions,
  StyleSheet,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import Text from '../../../components/Text';
import * as yup from 'yup';
import Button from '../../../components/Button';
import Heading from '../../../components/Heading';
import HStack from '../../../components/HStack';
import Icon from '@expo/vector-icons/Feather';
import RegisterActionBar from '../../../components/RegisterActionBar';
import RegisterPrevButton from '../../../components/RegisterPrevButton';
import {useDispatch} from 'react-redux';
import {RegistrationData} from '../types';
import {setRegisterData} from '../registerReducer';
import ScreenWrapper from '../components/ScreenWrapper';
import isWeb from '../../../utils/isWeb';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import TextInput from '../../../components/TextInput';
import shouldAutoFocus from '../../../utils/shouldAutoFocus';

const emailValidationSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email'),
});

const Email = ({navigation}) => {
  const dispatch = useDispatch();
  const {width} = useWindowDimensions();
  const {control, handleSubmit} = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(emailValidationSchema),
  });

  const handleEmailSubmit = (values: {email: string}) => {
    const registrationData: RegistrationData = {
      email: values.email,
    };
    //@ts-ignore
    dispatch(setRegisterData(registrationData));
    navigation.navigate('Phone');
  };

  return (
    <ScreenWrapper alignTop>
      <SafeAreaView
        style={[
          styles.safeAreaView,
          isWeb && {backgroundColor: '#ffffff', width: width / 3},
        ]}>
        <RegisterActionBar step={1} />
        <ScrollView
          style={styles.scrollView}
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={styles.scrollContent}>
          <View style={styles.view}>
            <Heading size="lg">Email</Heading>
            <Text style={styles.text}>
              Type in a valid email address.
            </Text>
            <Text style={styles.text}>
              The code is case sensitive.
            </Text>
            <TextInput
              //@ts-ignore
              control={control}
              name="email"
              placeholder="e.g johndoe@xyz.com"
              label="Email"
              keyboardType="email-address"
              autoCapitalize="none"
              InputRightElement={
                <TouchableOpacity style={styles.iconButton}>
                  <Icon name={'mail'} size={24} color="grey" />
                </TouchableOpacity>
              }
              autoFocus={shouldAutoFocus(true)}
            />
          </View>
        </ScrollView>
        <HStack style={styles.hStack}>
          <RegisterPrevButton />
          <Button
            // isDisabled={!isValid}
            onPress={handleSubmit(handleEmailSubmit)}
            style={styles.button}>
            Next
          </Button>
        </HStack>
      </SafeAreaView>
    </ScreenWrapper>
  );
};

const styles = StyleSheet.create({
  safeAreaView: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
    marginHorizontal: 8,
  },
  scrollContent: {
    flexGrow: 1,
  },
  view: {
    marginHorizontal: 24,
    marginTop: 16,
  },
  text: {
    marginTop: 16,
    fontSize: 18,
  },
  iconButton: {
    paddingHorizontal: 8,
  },
  hStack: {
    marginHorizontal: 24,
    marginTop: 'auto',
    marginBottom: 16,
  },
  button: {
    marginHorizontal: 8,
    flex: 1,
  },
});

export default Email;
